import {ProjectFeatureFlag} from 'common/report/constants';
import {ContentType, Dashboard} from 'common/report/dashboards/types';
import {CurrentProject} from 'common/report/model-resources/projects';
import {isAllowedSuperadminOverride} from 'common/report/util/saved-entities';

export const dashboardUtils = {
  canEditDashboard,
};

//TODO rename contentData to contentParams
export interface ContentDetails {
  contentId?: string;
  contentParams?: any;
  contentType: ContentType;
}

function canEditDashboard(dashboard: Pick<Dashboard, 'allow_staff_override' | 'is_superadmin' | 'can_update_basic'>) {
  return dashboard.can_update_basic || isAllowedSuperadminOverride(dashboard);
}

export function isTextCardAlignmentEnabled(project: CurrentProject) {
  return project?.hasFeatureFlag(ProjectFeatureFlag.TextCardAlignment);
}

export function getCardIdFromContent(contentId, contentType: ContentType) {
  return `${contentType}-${contentId}`;
}

export function isNestedDashboardsEnabled(project: CurrentProject) {
  return project?.hasFeatureFlag(ProjectFeatureFlag.NestedDashboards);
}
